import React, { useEffect, useRef, useState } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useEscapeKeyContext } from "../../contexts/UseEscapKeyContext";
import { capitalizeFirstLetter, sanitizeNumberInput } from "../../utils/helper";
import ReactPaginate from "react-paginate";
import ManagePincodesCapacityForm from "./ManagePincodesCapacityForm";
import TableHeader from "../common/table/TableHeader";
import TableSkeleton from "../common/table/TableSkeleton";
import handleError from "../../constant/handleError";
import checkNetworkStatus from "../common/networkStatus/CheckNetworkStatus";
import axiosInstance from "../../utils/AxiosInstance";
import useShowAlert from "../../utils/AlertUtiles";
import uRLs from "../../utils/baseUtils";
import DeletePopup from "../../constant/DeletePopup";

const tabsConfig = [
  {
    label: " Details",
    key: "VIEW",
    icon: <i className="bx bx-user font-18" />,
  },
  {
    label: "Pincode Areas",
    key: "PINCODE",
    icon: <i className=" bx bx-map font-18" />,
  },
  {
    label: "Settings",
    key: "CAPACITY",
    icon: <i className="bx bx-cog font-18"></i>,
  },
];

function ViewGangLeader({ onClose = () => {}, isData = {}, setData,isViewModelOpen }) {
  const [activeTab, setActiveTab] = useState("VIEW");
  const [errors, setErrors] = useState(false);
  
  const [isPincodeData, setPincodeList] = useState([]);
  const [capacity, setCapacity] = useState(isData.capacityInAcres);
  const capacityRef = useRef(null);
  
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [showManageForm, setShowManageForm] = useState(false);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [itemToDelete, setItemToDelete] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedPincode, setSelectedPincode] = useState(null);  

  const [loading, setLoading] = useState({
    listPincode: false,
    addPincode: false,
    deletePincode: false,
    addcapacity: false,
  });

  const { useEscapeKey } = useEscapeKeyContext();
  
  const handleEscapeKeyPress = () => {
    if (isDeleteDialogOpen) {     
      setIsDeleteDialogOpen(false);
    } else if(showManageForm){
      setShowManageForm(false);
    }
      else if (isViewModelOpen) {   
      onClose();
    } 
  };
  useEscapeKey(handleEscapeKeyPress);

  const handleManageOpen = (type, data = null) => {
    if (data) {
      setIsEditMode(true);
      setSelectedPincode(data);
    } else {
      setIsEditMode(false);
      setSelectedPincode(null);
    }
    setShowManageForm(true);
  };

  const handleManageClose = () => {
    setShowManageForm(false);
    setLoading(false);
    setIsEditMode(false);
    setSelectedPincode(null);
  };

  const headersPincode = ["S.No", "Date", "Pincode", "Action"];

  const showAlert = useShowAlert();

  const handlelistPincode = async (page = 0) => {
    setLoading((prev) => ({ ...prev, listPincode: true }));
    checkNetworkStatus();

    try {
      const response = await axiosInstance.get(`gangleader/admin/pincode/${isData?._id}?pageno=${page + 1}&limit=${uRLs.PER_PAGE}`);
      if (
        response &&
        response?.data?.status &&
        response?.data?.results?.length > 0
      ) {
        setPincodeList(response?.data?.results);
      }

      if (response?.data?.results?.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response?.data.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, listPincode: false }));
    }
  };
  const handleAddorUpdateCapacity = async (capacityValue) => {
    const numericCapacity = parseFloat(capacityValue);
    if (isNaN(numericCapacity) || numericCapacity <= 0) {
      setErrors({
        capacity: "Please enter a valid capacity (number greater than 0).",
      });
      setCapacity(String(isData.capacity || ""));
      return;
    }

    setErrors({});

    const formattedCapacity = numericCapacity;
    setCapacity(formattedCapacity);

    setLoading((prev) => ({ ...prev, addcapacity: true }));
    checkNetworkStatus();

    const id = isData._id;

    const data = {
      capacityInAcres: Number(formattedCapacity),
    };

    try {
      const response = await axiosInstance.patch(
        `partner/admin/capacity/${id}`,
        data
      );

      if (response && response?.data?.status) {
        setCapacity(
          String(response?.data?.results?.capacityInAcres || formattedCapacity)
        );

        setData((prevTableData) =>
          prevTableData.map((row) =>
            row._id === id
              ? {
                  ...row,
                  capacityInAcres: response?.data?.results?.capacityInAcres,
                }
              : row
          )
        );
        setData((prevTableData) =>
          prevTableData.map((row) => {
            if (row._id === id) {      
              const updatedCapacity = response?.data?.results?.capacityInAcres;
            
              isData.capacityInAcres = updatedCapacity;
              return { ...row, capacityInAcres: updatedCapacity };
            }
            return row;
          })
       );
        showAlert("success", response?.data?.message);
      }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, addcapacity: false }));
    }
  };
  useEffect(() => {
    if (activeTab === "PINCODE") {
      handlelistPincode();
    }
  }, [activeTab]);  

  // const handleCapacityBlur = () => {
  //   if (capacity && String(isData.capacity) !== capacity) {
  //     handleAddorUpdateCapacity(capacity);
  //   } else if (String(isData.capacity) === capacity) {
  //     const numericCapacity = parseFloat(capacity);
  //     if (!isNaN(numericCapacity)) {
  //       setCapacity(numericCapacity.toFixed(2));
  //     }
  //   }
  // };

  const openDeleteModal = (item) => {
    setItemToDelete(item);
    setIsDeleteDialogOpen(true);
  };

  const confirmDelete = () => {
    handleDelete(itemToDelete);
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = async (data) => {
    setLoading((prev) => ({ ...prev, deletePincode: true }));
    try {
      const response = await axiosInstance.delete(
        `gangleader/admin/pincode/${data._id}`
      );
      if (response && response.data.results) {
        showAlert("success", response?.data?.message);
        setTotalItems((prev) => prev - 1);
        setPincodeList((currentInstaItems) =>
          currentInstaItems.filter((item) => item._id !== data._id)
        );
      }
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, deletePincode: false }));
    }
  };

  const stopEventPropagation = (e) => e.stopPropagation();
  return (
    <>
      <div className={showManageForm || isDeleteDialogOpen ?"":"modal-backdrop show"}></div>
      <div
        className="modal show d-block"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl"
          onClick={stopEventPropagation}>
          {" "}
         
          <div className="modal-content ">
            <div className="modal-header ">
              <h6 className="modal-title ">
                Captain: {isData.name || "Details"}
              </h6>
              <button
                type="button"
                className="btn-close border"
                onClick={onClose}
              ></button>
            </div>

            <div className="d-flex" style={{ minHeight: "75vh" }}>
              <div
                className="border-end bg-light p-3"
                style={{ width: 250, flexShrink: 0 }}
              >
                <h6 className="text-uppercase text-muted mb-3 small">
                  Navigation
                </h6>
                <ul className="list-unstyled mb-0">
                  {tabsConfig.map((tab) => (
                    <li
                      key={tab.key}
                      className={`d-flex align-items-center mb-2 p-2 rounded ${
                        activeTab === tab.key
                          ? "bg-primary text-white shadow-sm"
                          : "text-dark hover-bg-light"
                      }`}
                      style={{ cursor: "pointer", transition: "all 0.2s" }}
                      onClick={() => {setActiveTab(tab.key); setCurrentPage(0);}}
                    >
                      <span className="me-2">{tab.icon}</span>
                      <span className="fw-medium">{tab.label}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex-grow-1 p-4 overflow-auto">
                {activeTab === "VIEW" && (<>
                 <h6 className="fw-bold mb-3 ms-1">Captain Information</h6>
                  <div className="p-3">          
                    <div className="row gy-3 border rounded p-3 bg-light">
                      <div className="col-12 d-flex justify-content-between">
                        <span className="fw-semibold text-secondary">
                          Role:
                        </span>
                        <span className="app-badge  bg-label-navy ">
                          {isData.role === "GANGLEADER"
                            ? "Captain"
                            : isData.role || "-"}
                        </span>
                      </div>

                      <div className="col-12 d-flex justify-content-between">
                        <span className="fw-semibold text-secondary">
                          Mobile:
                        </span>
                        <span className="text-dark">
                          <a href={`tel:+91${isData?.mobileNumber}`} onClick={(e) => e.stopPropagation()} className="text-black">{isData.mobileNumber || "-"}</a>
                        </span>
                      </div>
                      {isData?.pincode && (
                        <div className="col-12 d-flex justify-content-between">
                          <span className="fw-semibold text-secondary">
                            Pincode:
                          </span>
                          <span className="text-dark">
                            {isData.pincode || "-"}
                          </span>
                        </div>
                      )}
                      {isData?.capacityInAcres && (
                        <div className="col-12 d-flex justify-content-between">
                          <span className="fw-semibold text-secondary">
                            Capacity:
                          </span>
                          <span className="badge rounded-pill bg-label-fall">
                            {isData.capacityInAcres}
                          </span>
                        </div>
                      )}
                      <div className="col-12 d-flex justify-content-between">
                        <span className="fw-semibold text-secondary">
                          KYC Status:
                        </span>
                        <span
                          className={`badge ${
                            isData.kycStatus === "APPROVED"
                              ? "bg-success"
                              : "bg-warning text-dark"
                          }`}
                        >
                          {capitalizeFirstLetter(isData.kycStatus) || "-"}
                        </span>
                      </div>

                      <div className="col-12 d-flex justify-content-between">
                        <span className="fw-semibold text-secondary">
                          Created At:
                        </span>
                        <span className="text-dark">
                          {
                            DateConverter.ISOToDisplayFormat(
                              DateConverter.convertToTimeZone(
                                isData?.createdAt,
                                uRLs.TIMEZONE
                              )
                            ).date
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  </>
                )}
                {activeTab === "PINCODE" && (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="fw-semibold mb-0">List of Pincode</h5>
                      <button
                        className={`btn btn-sm btn-primary`}
                        onClick={() => handleManageOpen(activeTab)}
                      >
                        <i className="bx bx-plus"></i>
                        Add Pincode
                      </button>
                    </div>

                    <div className="col-col-12 ">
                      <div className="card mb-0">
                        <div className="card-body p-0">
                          <table className="table align-middle table-hover mb-0 cursor-pointer ">
                            <TableHeader headers={headersPincode} />
                            <tbody>
                              {loading.listPincode ? (
                                <TableSkeleton
                                  rows={5}
                                  columns={[200, 200, 200, 100]}
                                />
                              ) : Array.isArray(isPincodeData) &&
                                isPincodeData.length > 0 ? (
                                isPincodeData.map((item, index) => (
                                  <tr key={item._id}>
                                    <td className="text-center">
                                      {totalItems -
                                        (currentPage * uRLs.PER_PAGE + index)}
                                    </td>
                                    <td className="text-center">
                                      {" "}
                                      {
                                        DateConverter.ISOToDisplayFormat(
                                          DateConverter.convertToTimeZone(
                                            item?.createdAt,
                                            uRLs.TIMEZONE
                                          )
                                        ).date
                                      }
                                    </td>

                                    <td className="text-center">
                                      <div className="font-13">
                                        {item.pincode}
                                      </div>
                                    </td>

                                    <td className="text-center">
                                      <div className=" d-flex justify-content-center order-actions">
                                        <button
                                          type="button"
                                          className="btn-label-primary shadow-none me-2"
                                          onClick={() =>
                                            handleManageOpen(activeTab, item)
                                          }
                                        >
                                          <i className="bx bx-pencil"></i>
                                        </button>
                                        <button
                                          type="button"
                                          className="btn-label-danger shadow-none me-2"
                                          onClick={() => openDeleteModal(item)}
                                        >
                                          <i className="bx bx-trash"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="13"
                                    className="text-center py-3 text-muted"
                                  >
                                    No records found in this list.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {totalPages > 0 && (
                          <div className="d-flex justify-content-center mt-3">
                            <ReactPaginate
                              previousLabel={"← Previous"}
                              nextLabel={"Next →"}
                              breakLabel={"..."}
                              onPageChange={({ selected }) => {
                                setLoading((prev) => ({ ...prev, list: true }));
                                setCurrentPage(selected);
                                handlelistPincode(selected);
                              }}
                              pageRangeDisplayed={5}
                              pageCount={totalPages}
                              containerClassName="pagination"
                              pageClassName="page-item"
                              pageLinkClassName="page-link"
                              previousClassName="page-item"
                              previousLinkClassName="page-link"
                              nextClassName="page-item"
                              nextLinkClassName="page-link"
                              breakClassName="page-item"
                              breakLinkClassName="page-link"
                              activeClassName="active"
                              forcePage={currentPage}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {activeTab === "CAPACITY" && (
                  <>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="card">
                          <div className="card-header p-3 bg-light-core">
                            <h6 className="mb-0 text-dark">Capacity Settings</h6>
                          </div>
                          <div className="card-body">
                            <div className="d-flex align-items-center">
                              <input
                                type="text"
                                id="capacity-input"
                                ref={capacityRef}
                                className={`form-control me-2 ${
                                  errors.capacity ? "is-invalid" : ""
                                }`}
                                autoComplete="off"
                                placeholder="Enter Capacity (e.g., 430.50)"
                                value={capacity}
                              onChange={(e) => {
                                  setErrors({}); 
                                  const sanitizedValue = sanitizeNumberInput(e.target.value);
                                  setCapacity(sanitizedValue);
                                }}
                               
                                // onBlur={handleCapacityBlur}
                                onKeyDown={(e) => {
                                  if (e.key === " " || e.key === "Spacebar") {
                                    e.preventDefault();
                                  }
                                }}
                              />

                              <button
                                className="btn btn-primary"
                                onClick={() =>
                                  handleAddorUpdateCapacity(capacity)
                                }
                                 disabled={
                                    loading.addcapacity ||
                                    Number(parseFloat(capacity).toFixed(2)) ===
                                      Number(parseFloat(isData.capacityInAcres || 0).toFixed(2))
                                  }
                              >
                                {loading.addcapacity ? (
                                  <CircularProgress
                                    size={22}
                                    className="text-white"
                                  />
                                ) : (
                                  <>
                                    <spna className="d-flex align-item-ceneter">
                                      {" "}
                                      <i className="bx bx-check me-1" />
                                      Save
                                    </spna>{" "}
                                  </>
                                )}
                              </button>
                            </div>

                            {/* Error message display */}
                            {errors.capacity && (
                              <div className="invalid-feedback d-block mt-1">
                                {errors.capacity}
                              </div>
                            )}

                            <div className="mt-3 text-muted small">
                              The current capacity is saved in **acres**.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                 {isDeleteDialogOpen && (
                <DeletePopup
                  buttonloading={loading.deletePincode}
                  onClose={() => setIsDeleteDialogOpen(false)}
                  onConfirm={confirmDelete}
                  Name=" Pincode"
                  message={`Do you want to delete these records? <br>This process cannot be undone.`}
                />
              )}
                {showManageForm && (
                <ManagePincodesCapacityForm
                  onClose={handleManageClose}
                  showManageForm={showManageForm}
                  setPincodeList={setPincodeList}
                  selectedPincode={selectedPincode}
                  setLoading={setLoading}
                  isEditMode={isEditMode}
                  activeTab={activeTab}
                  partnerId={isData._id}
                  setTotalItems={setTotalItems}
                  loading={loading}
                />
              )}
              </div>
            </div>
          </div>
        </div>
      </div>
     
   
    </>
  );
}

export default ViewGangLeader;
